/* eslint-disable no-undef */
import React, { useCallback, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { REPOSITORY } from '../../api/repository/Repository'
import { useCompanyData } from '../../utils/hooks/company/useCompanyData'
import { loginUser, useAuthDispatch } from '../../utils/login'
import LoadingView from '../../components/Loading/LoadingView'
function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}
export default function Login() {
  const { searchCompanyData } = useCompanyData()
  const dispatch = useAuthDispatch()
  const navigate = useNavigate()
  const query = useQuery()
  const handleLogin = useCallback(async () => {
    const payload = { sGuidLogin: query.get('t') }
    try {
      const response = await loginUser(dispatch, payload.sGuidLogin)
      if (!response.sUsuario) return
      REPOSITORY.local.activity.saveActivity(Date.now())
      localStorage.setItem('token', query.get('t'))
      REPOSITORY.local.activity.saveActivity(Date.now())
      await searchCompanyData(response.oEmpresa[0]?.sEmpresa)
      REPOSITORY.local.activity.saveActivity(Date.now())
      await REPOSITORY.wsEmpresa.company
        .getRegions()
        .then((res) => {
          REPOSITORY.local.company.setRegions(res?.data)
        })
        .catch((error) => {
          console.error(error)
        })
      navigate('/')
    } catch (error) {
      console.error(error)
      localStorage.clear()
      window.location.replace(process.env.REACT_APP_LOGIN_REDIRECT)
    }
  }, [dispatch, navigate, query])

  useEffect(() => {
    if (query.get('t')) {
      REPOSITORY.local.company.eraseData()
      handleLogin()
    } else {
      localStorage.clear()
      window.location.replace(process.env.REACT_APP_LOGIN_REDIRECT)
    }
  }, [handleLogin, query])
  return <LoadingView open={true} />
}
